import type { FeatureFlag, FeatureFlagState } from '../../../featureFlags/FeatureFlag';

const STATES_THAT_OVERRIDE_GRANTS: readonly FeatureFlagState[] = ['off', 'on', 'internal'];

export type FeatureRow = {
  readonly key: string;
  readonly label: string;
  readonly registered: boolean;
  readonly overridingState?: FeatureFlagState;
};

const overridingStateOf = ({ kind, state }: FeatureFlag): FeatureFlagState | undefined =>
  kind === 'release-flag' && STATES_THAT_OVERRIDE_GRANTS.includes(state) ? state : undefined;

export const buildFeatureRows = (served: readonly FeatureFlag[], heldAtLoad: readonly string[]): FeatureRow[] => {
  const servedKeys = new Set(served.map(({ name }) => name));
  const registeredRows = served.map((flag) => ({
    key: flag.name,
    label: flag.label,
    registered: true,
    overridingState: overridingStateOf(flag),
  }));
  const unregisteredRows = heldAtLoad
    .filter((key) => !servedKeys.has(key))
    .map((key) => ({ key, label: key, registered: false }));

  return [...registeredRows, ...unregisteredRows].sort((left, right) => left.label.localeCompare(right.label));
};
